import { STEP_NODE_STATUS } from '../PathToSubmission.constants';

// Theme-token resolvers (not static palette hex) so the rail flips with the mode:
// the active/upcoming node border, number, and soft halo all read from the palette.
const NODE_BORDER_COLOR = {
  [STEP_NODE_STATUS.CURRENT]: palette => palette.warning.main,
  [STEP_NODE_STATUS.TODO]: palette => palette.divider,
};

const NODE_NUMBER_COLOR = {
  [STEP_NODE_STATUS.CURRENT]: 'warning.dark',
  [STEP_NODE_STATUS.TODO]: 'text.secondary',
};

const NODE_RING_COLOR = {
  [STEP_NODE_STATUS.BLOCKING]: palette => palette.error.extraSoft,
  [STEP_NODE_STATUS.CURRENT]: palette => palette.warning.extraSoft,
};

export const stepWrapperStyles = {
  flex: 1,
  minWidth: 0,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  cursor: 'pointer',
};

export const getConnectorStyles = isDone => ({
  position: 'absolute',
  top: '16px',
  left: '-50%',
  width: '100%',
  height: '3px',
  zIndex: 0,
  backgroundColor: ({ palette }) => (isDone ? palette.success.soft : palette.divider),
});

export const getNodeStyles = nodeStatus => ({
  position: 'relative',
  zIndex: 1,
  boxSizing: 'border-box',
  width: '34px',
  height: '34px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  backgroundColor: 'background.paper',
  border: ({ palette }) => {
    const borderColor = NODE_BORDER_COLOR[nodeStatus]?.(palette);

    return borderColor ? `2px solid ${borderColor}` : 'none';
  },
  color: NODE_NUMBER_COLOR[nodeStatus] ?? 'inherit',
  boxShadow: ({ palette }) => {
    const ringColor = NODE_RING_COLOR[nodeStatus]?.(palette);

    return ringColor ? `0 0 0 4px ${ringColor}` : 'none';
  },
});

export const labelStyles = {
  marginTop: '8px',
  maxWidth: '120px',
};

const STATUS_LABEL_COLOR = {
  [STEP_NODE_STATUS.DONE]: 'success.main',
  [STEP_NODE_STATUS.BLOCKING]: 'error.main',
  [STEP_NODE_STATUS.CURRENT]: 'warning.main',
  [STEP_NODE_STATUS.TODO]: 'text.secondary',
};

export const getStatusLabelStyles = nodeStatus => ({
  marginTop: '2px',
  textTransform: 'uppercase',
  color: STATUS_LABEL_COLOR[nodeStatus] ?? 'text.secondary',
});
